import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { Product } from 'src/app/products/models/product.model';
import { NotApplicablePipe } from 'src/app/shared/pipes/not-applicable.pipe';
import { RoundoffPipe } from 'src/app/shared/pipes/roundoff.pipe';

@Component({
  standalone: true,
  selector: 'dimension-and-weight',
  templateUrl: './dimension-and-weight.component.html',
  styleUrls: ['./dimension-and-weight.component.scss'],
  imports: [
    CommonModule,
    RoundoffPipe,
    NotApplicablePipe
  ]
})
export class DimensionAndWeightComponent {
  readonly product = input<Product>({} as Product);

  // Check if there's any meaningful weight and dimension data to display
  readonly hasWeightAndDimensionData = computed(() => {
    const productData = this.product();

    return !!(
      (productData?.dimensions && productData.dimensions !== null && productData.dimensions !== '') ||
      (productData?.weight && productData.weight !== null && productData.weight > 0) ||
      (productData?.unit && productData?.unit?.display_name && productData?.unit?.display_name !== 'NOS' && productData?.unit?.display_name !== 'numbers') ||
      (productData?.unit && productData?.unit?.name && productData?.unit?.name !== 'NOS' && productData?.unit?.name !== 'numbers') ||
      (productData?.manufacturer && productData.manufacturer !== null && productData.manufacturer !== '') ||
      (productData?.country_of_origin && productData.country_of_origin !== null && productData.country_of_origin !== '')
    );
  });
}


